<div fxLayout="row" fxLayoutAlign="start center" class="action-row mb1">
	<div class="action-title">Coming soon</div>
</div>

<div fxFlex="1 0 0">
	<p>This is a feature in development and will be available soon.</p>
</div>
